import React from "react";

import { useNavigate } from "utils";

import { Col, Link, Row, StickyFooter } from "components";

export const PayoutStickyButtons = ({
  absolute = false, // set to true, in order to position the footer in a drawer, for example
  primary,
  secondary,
  handleBack,
  extra,
  size = "tiny",
  mixpanelText,
  backButtonLink,
  backButtonText = "",
}) => {
  const navigate = useNavigate();

  const handleBackButtonClicked = () => {
    if (backButtonLink) {
      navigate(backButtonLink);
    } else {
      handleBack();
    }
  };

  const showBackButton = handleBack || backButtonLink;

  return (
    <StickyFooter absolute={absolute} size={size}>
      {extra}
      <Row align="middle" style={{ width: "100%" }}>
        {/* prelint-ignore-col */}
        {showBackButton && (
          <Col sm={!secondary ? 8 : 4} md={!secondary ? 8 : 4}>
            <Link onClick={handleBackButtonClicked} mixpanelText={mixpanelText}>
              {backButtonText || "back"}
            </Link>
          </Col>
        )}
        <Col sm={showBackButton ? (!secondary ? 16 : 20) : 24} md={showBackButton ? (!secondary ? 16 : 20) : 24} className="margin-top-50 margin-bottom-100">
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            {secondary}
            {primary}
          </div>
        </Col>
      </Row>
    </StickyFooter>
  );
};
